import { ServiceFormScreen } from '@/components/services/service-form-screen';
import React from 'react';

/**
 * Rota de criação. A tela é a mesma de edição (`ServiceFormScreen`); sem
 * `serviceId` ela abre em modo criar. `fromServiceId`/`fromTemplateId` na query
 * são lidos lá dentro.
 */
export default function CreateServiceScreen() {
  return <ServiceFormScreen />;
}
